import Records from './assets/img/ic-records.svg'
import Blockchain from './assets/img/ic-blockchain.svg'
import Dataroom from './assets/img/ic-dataroom.svg'
import Analysis from './assets/img/ic-analysis.svg'
import SearchAI from './assets/img/ic-search-ai.svg'
import Interconnect from './assets/img/ic-interconnect.svg'

import Reduce from './assets/img/ic-reduce.svg'
import FileSecure from './assets/img/ic-file-secure.svg'
import MultiChannel from './assets/img/ic-multi-channel.svg'

import userImagemale1 from './assets/userProfile/profile-pic-male-1.png'
import userImagemale2 from './assets/userProfile/profile-pic-male-2.png'
import userImagemale3 from './assets/userProfile/profile-pic-male-3.png'
import userImagemale4 from './assets/userProfile/profile-pic-male-4.png'
import userImagepradeep from './assets/userProfile/profile-pic-pradeep.png'
import brandingConfig from '../../../../../config/brandingConfig'


export const authData = {
  finance: {
    header: {
      text1: 'AI-Powered Record Management for Finance Professionals:',
      text2: 'Automate Compliance, Amplify Efficiency',
      label: 'AI That Turns Records Into Insights & Intelligence',
      trialDays: brandingConfig.freeTrialDays,
    },
    features: [
      {
        title: 'AI-Powered Record & File Management',
        desc: 'Automate financial records with AI, reducing manual work by 85% while ensuring compliance-ready classification & secure storage.',
        imgSrc: Records,
      },
      {
        title: 'Blockchain Security & Compliance',
        desc: 'Secure financial records with blockchain encryption and automated compliance monitoring for GDPR, SOX, and industry-specific regulations.',
        imgSrc: Blockchain,
      },
      {
        title: 'Smart Document Search Using AI',
        desc: 'Instantly find financial documents with AI-driven natural language search—no manual effort, just quick, secure access.',
        imgSrc: SearchAI,
      },
      {
        title: 'Secure Data Room & Digital Signing',
        desc: 'Share financial documents securely with digital signing, complete audit trails, and strict regulatory compliance.',
        imgSrc: Dataroom,
      },
      {
        title: 'Compliance Analytics & Monitoring',
        desc: 'Generate financial compliance reports in real-time, track audits, and maintain regulatory adherence effortlessly.',
        imgSrc:  Analysis,
      },
      {
        title: 'Multi-Channel Record Management',
        desc: 'Integrate with banking systems, emails, and financial tools to automate secure document handling.',
        imgSrc: Interconnect,
      },
    ],

    saving: {
      headerTitle: 'What You Will Save with RecordsKeeper.AI',
      saving1: {
        title: 'Reduce Manual work by',
        percentage: '85%',
      },
      saving2: {
        title: 'Cut Audit Preparation Time by',
        percentage: '75%',
      },
      pointers: {
        point1: 'End compliance headaches with AI-powered record management',
        point2: 'Secure, audit-ready financial records with blockchain verification',
        point3: 'Instant document access, anytime',
      },
    },

    benefits: {
      headerTitle: 'Benefits of RecordsKeeper.AI',
      benefitsList: [
        {
          title: 'Reduce Manual Work by 85%',
          desc: 'Automate document handling, processing and focus on strategic financial analysis & tasks, not paperwork.',
          img: Reduce,
        },
        {
          title: 'Enhanced Security & Compliance',
          desc: 'Maintain perfect regulatory compliance with blockchain-backed security and audit trails.',
          img: FileSecure,
        },
        {
          title: 'Instant Document Access',
          desc: 'Find any record, file & doc in seconds with AI-powered natural language search in ChatGPT-lookalike app.',
          img: MultiChannel,
        },
      ],
    },

    testimonials: [
      {
        msg: 'RecordsKeeper.AI has revolutionized how we handle client documentation. We have reduced our document processing time by 80%.',
        username: 'Michael Anderson',
        position: 'Managing Partner',
        userImage: userImagemale1,
      },
      {
        msg: 'After 15 years in accounting, I have never seen a more efficient system. The compliance automation handles GDPR seamlessly.',
        username: 'Pradeep Kumar',
        position: 'Founder, Robomart',
        userImage: userImagepradeep,
      },
      {
        msg: 'Managing corporate compliance for multiple subsidiaries used to be a nightmare. Data rooms and meeting management have made my job easier.',
        username: 'David Wilson',
        position: 'CEO, FinGrow',
        userImage: userImagemale3,
      },
    ],

    faqs: [
      {
        title: 'How quickly can we get started with RecordsKeeper.AI?',
        desc: 'You can start using RecordsKeeper.AI immediately after sign up. Our AI begins organizing your documents as soon as you upload them.',
      },
      {
        title: 'Is there a limit on the number of documents I can store?',
        desc: 'Our flexible pricing plans scale with your needs. Whether you`re a small firm managing thousands of documents or a large enterprise with millions of records, we have plans designed to accommodate your storage requirements while maintaining optimal performance.',
      },
      {
        title: 'Can I try RecordsKeeper.AI before committing?',
        desc: `Yes! We offer a ${brandingConfig.freeTrialDays}-day trial that gives you full access to all features. Experience how RecordsKeeper.AI can transform your record management firsthand.`,
      },
    ],
  },

  legal: {
    header: {
      text1: 'AI-Powered Record Management for Legal Professionals',
      text2: 'Ensure Compliance, Strengthen Security, & Streamline Legal Workflows',
      label: 'Transform Legal Record-Keeping with AI & Blockchain',
      trialDays: brandingConfig.freeTrialDays,
    },
    features: [
      {
        title: 'AI-Powered Record & File Management',
        desc: 'Streamline case file management with AI, ensuring accurate classification and reducing manual workload.',
        imgSrc: Records,
      },
      {
        title: 'Blockchain Security & Compliance',
        desc: 'Secure legal documents with blockchain-backed security, ensuring tamper-proof records and regulatory compliance.',
        imgSrc: Blockchain,
      },
      {
        title: 'Smart Document Search Using AI',
        desc: 'Retrieve case files instantly using AI-powered natural language search, eliminating manual document searches.',
        imgSrc: SearchAI,
      },
      {
        title: 'Secure Data Room & Digital Signing',
        desc: 'Share confidential legal documents securely with encrypted e-signatures, ensuring full audit trails.',
        imgSrc: Dataroom,
      },
      {
        title: 'Compliance Analytics & Monitoring',
        desc: 'Track document access, monitor legal compliance, and generate audit-ready reports with AI-powered analytics.',
        imgSrc:  Analysis,
      },
      {
        title: 'Multi-Channel Record Management',
        desc: 'Integrate seamlessly with legal management systems, email, and encrypted messaging for better case handling.',
        imgSrc: Interconnect,
      },
    ],

    saving: {
      headerTitle: 'What You Will Save with RecordsKeeper.AI',
      saving1: {
        title: 'Reduce Manual work by',
        percentage: '85%',
      },
      saving2: {
        title: 'Cut Audit Preparation Time by',
        percentage: '75%',
      },
      pointers: {
        point1: 'Eliminate compliance burdens with AI-powered legal record management',
        point2: 'Secure, audit-ready legal documents with blockchain verification',
        point3: 'Instant access to case files, contracts, and legal records anytime',
      },
    },

    benefits: {
      headerTitle: 'Benefits of RecordsKeeper.AI',
      benefitsList: [
        {
          title: 'Reduce Manual Work by 85%',
          desc: 'Automate legal document handling, processing, and compliance tracking—freeing up time for case strategy, not paperwork.',
          img: Reduce,
        },
        {
          title: 'Enhanced Security & Compliance',
          desc: 'Ensure airtight regulatory compliance with blockchain-backed security, tamper-proof audit trails, and granular access controls.',
          img: FileSecure,
        },
        {
          title: 'Instant Document Access',
          desc: 'Find contracts, case files, and legal records in seconds using AI-powered natural language search—just ask, and retrieve instantly.',
          img: MultiChannel,
        },
      ],
    },

    testimonials: [
      {
        msg: 'RecordsKeeper.AI has transformed how we manage case files. Retrieving legal documents is now instant, saving us hours every week.',
        username: 'Michael Anderson',
        position: 'Managing Partner',
        userImage: userImagemale1,
      },
      {
        msg: 'After 15 years in legal practice, I have never seen a more efficient system. Compliance automation ensures we meet GDPR and HIPAA seamlessly.',
        username: 'James Kelly',
        position: 'Founder, Kelly & Brooks',
        userImage: userImagemale2,
      },
      {
        msg: 'Managing legal compliance for multiple clients used to be overwhelming. Secure data rooms and automated workflows have made my job easier.',
        username: 'David Wilson',
        position: 'CEO of FinGrow',
        userImage: userImagemale3,
      },
    ],

    faqs: [
      {
        title: 'How quickly can we get started with RecordsKeeper.AI?',
        desc: 'You can start using RecordsKeeper.AI immediately after sign up. Our AI begins organizing your documents as soon as you upload them.',
      },
      {
        title: 'Is there a limit on the number of documents I can store?',
        desc: 'Our flexible pricing plans scale with your needs. Whether you`re a small firm managing thousands of documents or a large enterprise with millions of records, we have plans designed to accommodate your storage requirements while maintaining optimal performance.',
      },
      {
        title: 'Can I try RecordsKeeper.AI before committing?',
        desc: `Yes! We offer a ${brandingConfig.freeTrialDays}-day trial that gives you full access to all features. Experience how RecordsKeeper.AI can transform your record management firsthand.`,
      },
    ],
  },

  gov: {
    header: {
      text1: 'AI-Powered Record Management for Government Agencies',
      text2: 'Secure, Compliant, and Efficient Record-Keeping for Public Sector Operations',
      label: 'Transform Government Record-Keeping with AI & Blockchain',
      trialDays: brandingConfig.freeTrialDays,
    },
    features: [
      {
        title: 'AI-Powered Record & File Management',
        desc: 'Automate government document organization with AI, ensuring accuracy, compliance, and reduced manual processing.',
        imgSrc: Records,
      },
      {
        title: 'Blockchain Security & Compliance',
        desc: 'Protect sensitive government records with blockchain encryption, ensuring security, transparency, and compliance.',
        imgSrc: Blockchain,
      },
      {
        title: 'Smart Document Search Using AI',
        desc: 'Instantly access government records with AI-driven search, streamlining public administration workflows.',
        imgSrc: SearchAI,
      },
      {
        title: 'Secure Data Room & Digital Signing',
        desc: 'Share and approve government documents securely with encrypted digital signatures and audit trails.',
        imgSrc: Dataroom,
      },
      {
        title: 'Compliance Analytics & Monitoring',
        desc: 'Generate compliance reports, track document access, and ensure adherence to government regulations.',
        imgSrc:  Analysis,
      },
      {
        title: 'Multi-Channel Record Management',
        desc: 'Integrate with government portals, emails, and secure communication systems for seamless document management.',
        imgSrc: Interconnect,
      },
    ],

    saving: {
      headerTitle: 'What You Will Save with RecordsKeeper.AI',
      saving1: {
        title: 'Reduce Manual work by',
        percentage: '85%',
      },
      saving2: {
        title: 'Cut Audit Preparation Time by',
        percentage: '75%',
      },
      pointers: {
        point1: 'Eliminate compliance burdens with AI-powered government record management',
        point2: 'Secure, audit-ready public records with blockchain verification',
        point3: 'Instant access to policies, reports, and classified records anytime',
      },
    },

    benefits: {
      headerTitle: 'Benefits of RecordsKeeper.AI',
      benefitsList: [
        {
          title: 'Reduce Manual Work by 85%',
          desc: 'Automate government document handling, processing, and compliance tracking—freeing up time for governance, not paperwork.',
          img: Reduce,
        },
        {
          title: 'Enhanced Security & Compliance',
          desc: 'Ensure airtight regulatory compliance with blockchain-backed security, tamper-proof audit trails, and granular access controls.',
          img: FileSecure,
        },
        {
          title: 'Instant Document Access',
          desc: 'Find policy documents, government reports, and classified files in seconds using AI-powered natural language search—just ask, and retrieve instantly.',
          img: MultiChannel,
        },
      ],
    },

    testimonials: [
      {
        msg: 'RecordsKeeper.AI has transformed how we manage government records. Retrieving critical documents is now instant, improving operational efficiency.',
        username: 'Michael Anderson',
        position: 'Government Records Manager',
        userImage: userImagemale1,
      },
      {
        msg: 'After two decades in public administration, I have never seen a more efficient system. Compliance automation ensures we meet GDPR and national regulations seamlessly.',
        username: 'James Kelly',
        position: 'Director, Public Sector Compliance',
        userImage: userImagemale2,
      },
      {
        msg: 'Managing multi-agency compliance used to be overwhelming. Secure data rooms and automated approvals have made record management effortless.',
        username: 'David Wilson',
        position: 'Chief Information Officer, GovTech',
        userImage: userImagemale3,
      },
    ],

    faqs: [
      {
        title: 'How quickly can we get started with RecordsKeeper.AI?',
        desc: 'You can start using RecordsKeeper.AI immediately after sign up. Our AI begins organizing your documents as soon as you upload them.',
      },
      {
        title: 'Is there a limit on the number of documents I can store?',
        desc: 'Our flexible pricing plans scale with your needs. Whether you`re a small firm managing thousands of documents or a large enterprise with millions of records, we have plans designed to accommodate your storage requirements while maintaining optimal performance.',
      },
      {
        title: 'Can I try RecordsKeeper.AI before committing?',
        desc: `Yes! We offer a ${brandingConfig.freeTrialDays}-day trial that gives you full access to all features. Experience how RecordsKeeper.AI can transform your record management firsthand.`,
      },
    ],
  },

  heatlcare: {
    header: {
      text1: 'AI-Powered Record Management for Healthcare',
      text2: 'Secure, Compliant, and Automated Record-Keeping for Healthcare Organizations',
      label: 'Transform Healthcare Record-Keeping with AI & Blockchain',
      trialDays: brandingConfig.freeTrialDays,
    },
    features: [
      {
        title: 'AI-Powered Record & File Management',
        desc: 'Transform medical records into structured, searchable data while ensuring HIPAA compliance and reducing manual processing by 85%',
        imgSrc: Records,
      },
      {
        title: 'Blockchain Security & Compliance',
        desc: 'Protect patient records with blockchain encryption, ensuring data security, privacy, and compliance with healthcare regulations.',
        imgSrc: Blockchain,
      },
      {
        title: 'Smart Document Search Using AI',
        desc: 'Instantly retrieve patient records using AI-driven search, improving workflows and reducing manual effort.',
        imgSrc: SearchAI,
      },
      {
        title: 'Secure Data Room & Digital Signing',
        desc: 'Share patient documents securely with encrypted e-signatures, detailed audit trails, and compliance-ready security.',
        imgSrc: Dataroom,
      },
      {
        title: 'Compliance Analytics & Monitoring',
        desc: 'Monitor compliance, track patient data access, and generate real-time regulatory reports.',
        imgSrc:  Analysis,
      },
      {
        title: 'Multi-Channel Record Management',
        desc: 'Automate healthcare document management with seamless EHR, email, and secure communication integrations.',
        imgSrc: Interconnect,
      },
    ],
    saving: {
      headerTitle: 'What You Will Save with RecordsKeeper.AI',
      saving1: {
        title: 'Reduce Manual work by',
        percentage: '85%',
      },
      saving2: {
        title: 'Cut Audit Preparation Time by',
        percentage: '75%',
      },
      pointers: {
        point1: 'Eliminate compliance burdens with AI-powered medical record management',
        point2: 'Secure, audit-ready patient records with blockchain verification',
        point3: 'Instant access to health records, anytime, anywhere',
      },
    },

    benefits: {
      headerTitle: 'Benefits of RecordsKeeper.AI',
      benefitsList: [
        {
          title: 'Reduce Manual Work by 85%',
          desc: 'Automate healthcare documentation, patient record handling, and compliance tracking—so medical professionals can focus on patient care, not paperwork.',
          img: Reduce,
        },
        {
          title: 'Enhanced Security & Compliance',
          desc: 'Ensure full HIPAA compliance with blockchain-backed security, tamper-proof audit trails, and secure access controls.',
          img: FileSecure,
        },
        {
          title: 'Instant Document Access',
          desc: 'Find patient records, prescriptions, and medical reports in seconds using AI-powered natural language search—just ask, and retrieve instantly.',
          img: MultiChannel,
        },
      ],
    },

    testimonials: [
      {
        msg: 'RecordsKeeper.AI has transformed how we manage patient records. Retrieving critical medical documents is now instant, improving patient care efficiency.',
        username: 'Dr. Michael Anderson',
        position: 'Chief Medical Officer',
        userImage: userImagemale1,
      },
      {
        msg: 'After 20 years in healthcare administration, I’ve never seen a more efficient system. Compliance automation ensures we meet HIPAA and GDPR seamlessly.',
        username: 'Pradeep Kumar',
        position: 'Director of Compliance, HealthFirst',
        userImage: userImagepradeep,
      },
      {
        msg: 'Managing medical records across multiple departments used to be overwhelming. Secure data rooms and automated workflows have made our processes seamless.',
        username: 'David Wilson',
        position: 'Head of IT, MediCare Group',
        userImage: userImagemale4,
      },
    ],

    faqs: [
      {
        title: 'How quickly can we get started with RecordsKeeper.AI?',
        desc: 'You can start using RecordsKeeper.AI immediately after sign up. Our AI begins organizing your documents as soon as you upload them.',
      },
      {
        title: 'Is there a limit on the number of documents I can store?',
        desc: 'Our flexible pricing plans scale with your needs. Whether you`re a small firm managing thousands of documents or a large enterprise with millions of records, we have plans designed to accommodate your storage requirements while maintaining optimal performance.',
      },
      {
        title: 'Can I try RecordsKeeper.AI before committing?',
        desc: `Yes! We offer a ${brandingConfig.freeTrialDays}-day trial that gives you full access to all features. Experience how RecordsKeeper.AI can transform your record management firsthand.`,
      },
    ],
  },
}
